import { render, staticRenderFns } from "./Electronpop.vue?vue&type=template&id=2f638fc1&scoped=true"
import script from "./Electronpop.vue?vue&type=script&lang=js"
export * from "./Electronpop.vue?vue&type=script&lang=js"
import style0 from "./Electronpop.vue?vue&type=style&index=0&id=2f638fc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f638fc1",
  null
  
)

export default component.exports